export default {"src":"/_next/static/media/box_svgrepo.com.4b3397a3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};